/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .controller('setAutoRegPasswordErrorCtrl', SetAutoRegPasswordErrorCtrl);

  SetAutoRegPasswordErrorCtrl.$inject = ['ute.datalayer.common.service', 'timerService', '$translate', '$state'];

  function SetAutoRegPasswordErrorCtrl(dataLayerService, timerService, $translate, $state) {
    var dataLayerPredefinedSection = window.ute.datalayer.common.service.DataLayerPredefinedSection;
    var dataLayerErrorType = window.ute.datalayer.common.service.ErrorType;
    var dataLayerErrorCategory = window.ute.datalayer.common.service.ErrorCategory;
    var dataLayerSections = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE];

    init();

    function init() {
      timerService.stopTimer();

      if (!!_.get($state, 'params.errorCode')) {
        var errorType = !_.get($state, 'params.api') ? dataLayerErrorType.USER : dataLayerErrorType.HTTP;

        dataLayerService.trackError({},
          errorType,
          _.get($state, 'params.errorCode'),
          _.get($state, 'params.errorMessage') || '',
          dataLayerErrorCategory.SELF_SERVE,
          '',
          _.get($state, 'params.api') || '',
          false,
          dataLayerSections,
          {mappingKey: 'autoReg.errorPage'});
      }
    }
  }
})();
